"use client";

import { useQuery } from "@tanstack/react-query";
import { getSdk } from "../sdk";
import { qk } from "../query-keys";

const PENDING_POLL_MS = 30_000;

export function usePendingApplicants(limit = 10) {
  return useQuery({
    queryKey: [...qk.applications.pending, limit],
    queryFn: async () => getSdk().applications.listPendingForMe(limit),
    staleTime: 15_000,
    refetchInterval: PENDING_POLL_MS,
    refetchIntervalInBackground: false,
  });
}
